if ((typeof Grundpreis) === 'undefined') { var Grundpreis = {}; }

Grundpreis.floatToString = function (numeric, decimals) {
  var amount = numeric.toFixed(decimals).toString();
  if(amount.match(/^\.\d+/)) {return "0"+amount; }
  else { return amount; }
}

Grundpreis.addCommas = function (moneyString) {
	return moneyString.replace(/(\d+)(\d{3}[\.,]?)/,'$1,$2');
}

Grundpreis.formatMoney = function (cents, format) {

  if (typeof cents == 'string') cents = cents.replace('.','');
  var value = '';
  var patt = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  switch(formatString.match(patt)[1]) {
    case 'amount':
      value = this.addCommas(this.floatToString(cents/100.0, 2));
      break;
    case 'amount_no_decimals':
      value = this.addCommas(this.floatToString(cents/100.0, 0));
      break;
    case 'amount_with_comma_separator':
      value = this.floatToString(cents/100.0, 2).replace(/\./, ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = this.addCommas(this.floatToString(cents/100.0, 0)).replace(/\./, ',');
      break;
  }
  return formatString.replace(patt, value);
};

/*
	getGrundpreis

	Parameters:

	grundpreisString - Product or variant title
	grundpreisPrice - Product or variant price (unformatted)

	returns: Formatted string, e.g. "€17,99/100 ml"

*/

Grundpreis.getGrundpreis = function (grundpreisString, grundpreisPrice) {
	/*

	Grundpreis-Regeln:

	- Bis 250 g/ml -> €/100 g bzw. €/100 ml
	- Über 250 g/ml -> €/kg bzw. €/l

	*/
	var rx = /((\d+)\s?x\s?)?(([0-9]+)([\.\,][0-9][0-9]?)?)\s?(m²|m³|g|kg|ml|cl|l|cm|qm|kbm|m)/g;
	var parsed = rx.exec(grundpreisString);
	if(parsed) {
	  if(parsed[2] && parsed[2] != "") {
	    var variantQuantity = parsed[2] * parsed[3].replace(',', '.');
	  } else {
      var variantQuantity = parsed[3].replace(',', '.');
    }
		var variantUnit = parsed[6];
		parsed = null; /* Reset index */
		var grundpreisUnit = "";
		var grundpreis = "";
		switch(variantUnit) {
			case 'g':
				if (variantQuantity <= 250) {
					grundpreisUnit = "100 g";
					grundpreis = (grundpreisPrice / variantQuantity) * 100;
				} else {
					grundpreisUnit = "kg";
					grundpreis = (grundpreisPrice / variantQuantity) * 1000;
				}
				break;
			case 'ml':
				if (variantQuantity <= 250) {
					grundpreisUnit = "100 ml";
					grundpreis = (grundpreisPrice / variantQuantity) * 100;
				} else {
					grundpreisUnit = "l";
					grundpreis = (grundpreisPrice / variantQuantity) * 1000;
				}
				break;
			case 'cl':
				if (variantQuantity <= 25) {
					grundpreisUnit = "100 ml";
					grundpreis = (grundpreisPrice / variantQuantity) * 10;
				} else {
					grundpreisUnit = "l";
					grundpreis = (grundpreisPrice / variantQuantity) * 100;
				}
				break;
			case 'cm':
				grundpreisUnit = "m";
				grundpreis = (grundpreisPrice / variantQuantity) * 100;
				break;
			default:
				grundpreisUnit = variantUnit;
				grundpreis = (grundpreisPrice / variantQuantity);
				break;
		}
		if(typeof theme != 'undefined' && typeof theme.moneyFormat != 'undefined') {
			return this.formatMoney(grundpreis, theme.moneyFormat) + "/" + grundpreisUnit;
		} else {
			return this.formatMoney(grundpreis, "€\{\{amount_with_comma_separator\}\}") + "/" + grundpreisUnit;
		}
	} else {
		return "";
	}
}
